import axios from "axios";

const CDP_API_BASE_URL =
  process.env.REACT_APP_CDP_API_BASE_URL || "https://clm-analytics.jagran.com/api/v1/cms";

const client = axios.create({
  baseURL: CDP_API_BASE_URL,
  timeout: 15000,
});

const CUSTOMER_REPORT_BEARER_TOKEN = process.env.REACT_APP_CUSTOMER_REPORT_BEARER_TOKEN || "";

const customerReportAuthHeaders = CUSTOMER_REPORT_BEARER_TOKEN
  ? { Authorization: `Bearer ${CUSTOMER_REPORT_BEARER_TOKEN}` }
  : {};

const customerReportClient = axios.create({
  baseURL:
    process.env.REACT_APP_CUSTOMER_REPORT_API_BASE_URL ||
    "https://clm-analytics.jagran.com/api/v1/",
  timeout: 15000,
  headers: customerReportAuthHeaders,
});

const withCustomerReportAuth = (config = {}) => ({
  ...config,
  headers: {
    ...config.headers,
    ...customerReportAuthHeaders,
  },
});

export const cdpService = {
  getAllProducts: () => client.get("/product/get-all"),

  getOverallRegistrationCount: () => client.get("/cdp/registration/get-overall-count"),
  getFilteredRegistrationCount: (payload) =>
    client.post("/cdp/registration/get-filtered-count", payload),
  getCustomerList: (payload) => client.post("/cdp/registration/get-customer-list", payload),
  getCustomerReportList: (params, config = {}) =>
    customerReportClient.get(
      "/cms/report/customer/list",
      withCustomerReportAuth({ ...config, params })
    ),
  getCustomerReportDetail: (id, params, config = {}) =>
    customerReportClient.get(
      `/cms/report/customer/detail/${encodeURIComponent(id)}`,
      withCustomerReportAuth({ ...config, params })
    ),
  getCustomerPurchaseHistoryDetail: (purchaseId, config = {}) =>
    customerReportClient.get(
      `/cms/report/customer/purchase-history/${encodeURIComponent(purchaseId)}`,
      withCustomerReportAuth(config)
    ),
  sendInvoice: (transactionId) =>
    axios.get(
      `${process.env.REACT_APP_SEND_INVOICE_API_BASE_URL || "https://clm-api.jagran.com/api/send-invoice/"}${encodeURIComponent(transactionId)}`,
      { timeout: 20000 }
    ),

  getOverallDemographicCount: () => client.get("/cdp/demographic/get-overall-count"),
  getFilteredDemographicCount: (payload) =>
    client.post("/cdp/demographic/get-filtered-count", payload),
  getDeviceGraph: () => client.get("/cdp/demographic/get-device-graph"),
  getProductChart: () => client.get("/cdp/demographic/get-product-chart"),
  getSignupTrend: (payload) =>
    client.post("/cdp/demographic/get-device-signup-trend-chart", payload),
  getWeeklySignupTrend: (payload) =>
    client.post("/cdp/demographic/get-weekly-signup-trend-chart", payload),
  getBounceRateChart: (payload) => client.post("/cdp/demographic/get-bouncerate-chart", payload),
  getActionRefChart: (payload) => client.post("/cdp/demographic/get-actionref-chart", payload),
  getRegistrationMethodChart: (payload) =>
    client.post("/cdp/demographic/get-regmethod-chart", payload),
  getGenderChart: (payload) => client.post("/cdp/demographic/get-gender-chart", payload),
  getAgeGroupChart: (payload) => client.post("/cdp/demographic/get-agegroup-chart", payload),
};

export default cdpService;
